// extracted by mini-css-extract-plugin
export default {"warningOverlay":"firestore-write-permission-provider_warningOverlay__ynB+p","blinker":"firestore-write-permission-provider_blinker__DafSv"};